/**
 * Basis-Klasse für Such-Funktionen
 *
 * @class SP.sitekit.search.Service
 */
SP.lang.Class.define("SP.sitekit.search.Service", {

	/**
	 * Verbindung zum RPC-Port
	 */
	connection: null,

	/**
	 * ID der Suchekonfiguration
	 */
	searchId: null,

	/**
	 * URL der Suchseite
	 */
	searchUrl: null,

	/** Solr Query Filter */
	filter: null,

	/** Solr Facetten Feldname (und queries) */
	facets: null,

	/** Solr Sort Field and order (default: "score:desc)*/
	sorting: null,

	/** Sprache, in der gesucht werden soll */
	lang: null,

	/** Solr-Core der verwendet werden soll */
	core: null,

	/** default Pagination*/
	pagination: null,

	/** default (zusatz) Felder für die Suche*/
	fields: null,

	/** spellcheck parameter */
	spellcheck: null,

	/** mit oder ohne wildcard Suche */
	wildcardSearch: null,

	/** Suchfeld, wenn nicht content */
	defaultSearchField: null,

	/** Werte für die default Suchfelder mit Angabe von boosts (zB: title^5.0 keywords^3.0 description^1.0 content^0.5 ) */
	boostParameter : null,

	statics: {

		/**
		 * SEARCH
		 * @var SP.net.rpc.client.Method
		 */
		SEARCH: new SP.net.rpc.client.Method(null, null, "SP\\SiteKit\\Rpc\\Search\\Service", "search"),

		/**
		 * SUGGEST
		 * @var SP.net.rpc.client.Method
		 */
		SUGGEST: new SP.net.rpc.client.Method(null, null, "SP\\SiteKit\\Rpc\\Search\\Service", "suggest"),

		/**
		 * GET_FACETS
		 * @var SP.net.rpc.client.Method
		 */
		GET_FACETS: new SP.net.rpc.client.Method(null, null, "SP\\SiteKit\\Rpc\\Search\\Service", "getFacets")
	},

	/**
	 *
	 * @param {} config
	 * @memberOf SP.solr.Service
	 * @private
	 * @memberOf SP.solr.Service
	 */
	init: function(config) {
		this.filter = [];
		this.facets = [];
		this.sorting = [];
		SP.lang.Object.apply(this, config);

		if (this.pagination === null) {
			this.pagination = {
				hitsPerPage:50,
				currentPage: 0
			};
		}

		this.connection = new SP.net.rpc.client.Connection(SP.env.rpcPortUrl);
	},

	suggest: function (query, options) {
		this.callRpc(SP.sitekit.search.Service.SUGGEST, query, options);
	},

	search: function (query, options) {
		this.callRpc(SP.sitekit.search.Service.SEARCH, query, options);
	},

	getFacets: function (query, factes, options) {
		this.factes = factes;
		this.callRpc(SP.sitekit.search.Service.GET_FACETS, query, options);
	},

	callRpc: function(method, query, options) {

		var param = {
				searchId: this.searchId,
				searchUrl: this.searchUrl,
				lang: this.lang,
				core: this.core,
				query: query
		};
		if (this.filter !== null) {
			param.filter = this.filter;
		}
		if (this.pagination !== null) {
			param.pagination = this.pagination;
		}
		if (this.fields !== null) {
			param.fields = this.fields;
		}
		if (this.spellcheck !== null) {
			param.spellcheck = this.spellcheck;
		}
		if (this.defaultSearchField !== null) {
			param.defaultSearchField = this.defaultSearchField;
		}
		if (this.sorting !== null) {
			param.sorting = this.sorting;
		}
		if (this.wildcardSearch !== null) {
			param.wildcardSearch = this.wildcardSearch;
		}
		if (this.facets !== null ) {
			param.facets = this.facets;
		}
		if (this.boostParameter !== null ) {
			param.boostParameter = this.boostParameter;
		}

		var me = this;

		options = options || {};

		var m = method.create(
			null, // keine Session
			param,
			{
				success: function(data) {
					if (options && SP.isFunction(options.success)) {
						options.success.call(options.scope || me, data);
					}
				},
				failure: (options && SP.isFunction(options.failure)) ? options.failure : null
			}
		);

		this.connection.invoke(m);
	},


	setCore: function(newCore) {
		if (newCore) {
			this.core = newCore;
		}
	},

	/**
	 * @public
	 * Fügt eine Filter (key-value kombination) hinzu oder überschreibt die
	 */
	addFilter: function (filterField, filterValue) {
		if (filterValue === null || filterValue === 1 || filterValue === '1') {
			filterValue = null;
		}
		this.setArrayObject(filterField, filterValue, this.filter, false);
	},

	/**
	 *
	 */
	addBoundingBoxFilter: function (field, slon, slat, elon, elat) {
		this.addFilter(field, "[" + slon + "," + slat + " TO " + elon + ", " + elat + "]");
	},

	/**
	 * @public
	 */
	clearFilter: function() {
		this.filter.length = 0;
	},

	/**
	 * @public
	 * Fügt ein Sortier-Feld (field-order kombination) hinzu oder überschreibt die
	 * des nagegebenen Feldes
	 */
	addSorting: function (sortField, sortOrder) {
		this.setArrayObject(sortField, sortOrder, this.sorting, true);
	},
	/**
	 * @public
	 */
	clearSorting: function() {
		this.sorting.length = 0;
	},

	/**
	 * @private
	 * Hilfsfunktion
	 * @param objectKey
	 * @param objectValue
	 * @param arrayObj
	 * @param allowDublicates optionaler parameter – ist default auf false gesetzt
	 */
	setArrayObject: function(objectKey, objectValue, arrayObj, allowDublicates) {
		allowDublicates = typeof allowDublicates !== "undefined" ? allowDublicates : false;

		if (arrayObj === null) {
			arrayObj = [];
		}

		if (allowDublicates === false) {
			var objectSet = false;
			for (var i = 0; i < arrayObj.length; i++) {
				if (arrayObj[i].field === objectKey) {
					arrayObj[i].value = objectValue;
					objectSet = true;
				}
			}
			if (objectSet === false) {
				arrayObj.push({
					"field" : objectKey,
					"value" : objectValue
				});
			}
		} else {
			arrayObj.push({
				"field" : objectKey,
				"value" : objectValue
			});
		}
	}
});